// Template: resources/views/_components/admin/media-library.blade.php

import Modal from './Modal';

import IconLibrary from './IconLibrary';
import UnsplashPicker from './UnsplashPicker';
import MediaPicker from './MediaPicker';

export default {

    name: "MediaLibrary",

    components: { IconLibrary, UnsplashPicker, MediaPicker, Modal },

    props: {
        supportedMediaTypes: { type: Array, default: () => (['upload']) },
        multiupload: { type: Boolean, default: false },
    },

    data() {
        return {
            appModelId: this.modelId,
            appModel: this.modelType,
            translations: {},
            activeEmbedTab: '',
            selectedMedia: [],
            isUploading: false,
            showTabs: true,
            onUseMediaCallback: null
        }
    },

    computed: {
        selectedMediaType() {
            switch (this.activeEmbedTab) {
                case '#unsplash':
                    return 'unsplash';
                case '#icons':
                    return 'icons';
                case '#upload':
                    return 'upload';
            }
        },

        isSelectable() {
            const selectableTypes = ['unsplash', 'icons'];
            return selectableTypes.includes(this.selectedMediaType);
        }
    },

    watch: {
        activeEmbedTab() {
            if (this.isSupportedMediaType('unsplash')) {
                this.$refs.unsplashPicker.clearSelection();
            }
            if (this.isSupportedMediaType('icon')) {
                this.$refs.iconLibrary.clearSelection();
            }
        }
    },

    created() {
        // reset
        this.selectedMedia = [];
    },

    methods: {
        isSupportedMediaType(type) {
            if (this.supportedMediaTypes.indexOf(type) >= 0) {
                return true;
            }
            return false;
        },

        selectMedia(media, callback) {
            this.selectedMedia = media;
            this.onUseMediaCallback = callback;
        },

        useSelectedMedia() {
            this.isUploading = true;
            if (this.selectedMediaType == 'unsplash' && this.onUseMediaCallback) {
                this.onUseMediaCallback(this.selectedMedia);
            }
            this.$bus.$emit('use-media-from-library', this.selectedMedia, this.selectedMediaType);
        },

        onPanelScroll(data) {
            window.requestAnimationFrame(() => {
                this.showTabs = data.direction == 'down' ? false : true;
            });
        }
    }
};
